import React from 'react';
import { Wrapper } from './CWNotification.styles';

const CWNotification = () => (
  <Wrapper>
    <h4>You are currently reviewing a product suggestion</h4>
    <p>The message input area will be blocked until you choose a recommendation or close the window.</p>
  </Wrapper>
);

export default CWNotification;
